import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indianCurrency'
})
export class IndianCurrencyPipe implements PipeTransform {
    transform(value: number | string, decimal: number = 2): string {
        if (value == null) return '';

        const num = Number(value);
        if (isNaN(num)) return '';

        const [integer, fraction = ''] = num.toFixed(decimal).split('.');

        // Indian grouping
        let lastThree = integer.slice(-3);
        let otherNumbers = integer.slice(0, -3);

        if (otherNumbers !== '') {
            lastThree = ',' + lastThree;
        }

        const formatted = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

        return fraction ? `${formatted}.${fraction}` : formatted;
    }
}